module.exports = __webpack_public_path__ + "static/media/jsDom.df1946f4.png";